import { render, staticRenderFns } from "./SpotlightRuleEditor.vue?vue&type=template&id=0e1fa390&"
import script from "./SpotlightRuleEditor.vue?vue&type=script&lang=js&"
export * from "./SpotlightRuleEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightRuleEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports